// app/javascript/controllers/expandable_table_poller_controller.js
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    shouldPoll: Boolean,
    interval: { type: Number, default: 30000 },
    url: String,
    frameId: String,
  }

  connect() {
    if (this.shouldPollValue) {
      this.startPolling()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.pollTimer = setInterval(() => {
      this.refreshFrame()
    }, this.intervalValue)
  }

  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
    }
  }

  refreshFrame() {
    // Get all expanded rows
    const expandedRows = []
    document.querySelectorAll('.expandable-row.expanded').forEach((row) => {
      const rowId = row.id.replace('row-', '')
      if (rowId) {
        expandedRows.push(rowId)
      }
    })

    // Build URL with expanded rows parameter
    const url = new URL(this.urlValue, window.location.origin)

    // Clear any existing expanded_rows params
    url.searchParams.delete('expanded_rows[]')

    // Add current expanded rows
    expandedRows.forEach((rowId) => {
      url.searchParams.append('expanded_rows[]', rowId)
    })

    // Find the frame and update it
    const frameId = this.frameIdValue || 'expandable_table_frame'
    const frame = document.getElementById(frameId)

    if (frame) {
      frame.src = url.toString()
    }
  }
}
